import React, { useState } from "react";
import { SafeAreaView, ScrollView, StatusBar, StyleSheet, View } from "react-native";
import { Text, InfoBox } from "../../components";
import { InfoBoxType, InfoBoxIconType } from "../../enums";
import { ThemeType } from "../../theme/theme";
import { Stack } from "../../components/layout/stack";
import { translate } from "../../i18n/translate";
import { useTheme } from "react-native-paper";
import { useIsMounted } from "../../hooks/useIsMounted";
import { useNavigation } from "@react-navigation/native";
import { theme as themeUiComponent, Button, typography } from "ui-components";
import { domusoResponsiveStyleHelper } from "../new/utils/domuso-responsive";
import { testProps } from "../../utils/testProps";
import { Grid, Container, Row, Column } from "ui-grid";
import { DomusoIcon } from "../../../assets/domuso-icon";
import { Footer } from "../../components/new/footer/footer";
interface SignUpConfirmedScreenParamList {
  email: string;
}

interface SignUpConfirmedScreenProps {
  route: { params: SignUpConfirmedScreenParamList };
}

export const SignUpConfirmedScreen = ({ route }: SignUpConfirmedScreenProps) => {
  const theme = useTheme();
  const styles = getStyles(theme as ThemeType);
  const isMounted = useIsMounted();
  const navigation = useNavigation();
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setLoading] = useState(false);
  const { params } = route;
  const { email } = params;

  if (!isMounted) {
    return null;
  }

  const returnToLoginHandler = async () => {
    navigation.navigate("SignIn");
  };

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={styles.scrollView}
        contentContainerStyle={styles.scrollableArea}>
        <StatusBar
          hidden={false}
          translucent={false}
          backgroundColor={themeUiComponent.colors.white}
          barStyle={"dark-content"}
        />
        <Grid>
          <Container>
            <Row>
              <Column span={{ xs: false, sm: 1, md: 2, lg: 3 }} />
              <Column span={{ xs: 12, sm: 10, md: 8, lg: 6 }}>
                <View>
                  <View style={{ marginVertical: 15 }}></View>
                  <Stack space="small">
                    <View style={{ alignItems: "center" }}>
                      <DomusoIcon height={45} width={45} color={themeUiComponent.colors.primary} />
                      <View style={{ marginTop: 10 }}>
                        <Text
                          style={styles.heading}
                          text={translate("authStack.confirmEmail") as string}
                        />
                      </View>
                      <View style={{ marginVertical: 30 }}>
                        <Text style={styles.text}>
                          {translate("authStack.confirmationPara0")}
                          <Text style={{ fontFamily: "Lato_700Bold" }}> {email}. </Text>
                          {translate("authStack.confirmationPara1")}
                          {"\n"}
                        </Text>
                        <Text style={styles.text} tx="authStack.confirmationPara2" />
                      </View>
                    </View>
                  </Stack>
                </View>
              </Column>
              <Column span={{ xs: false, sm: 1, md: 2, lg: 3 }} />
            </Row>
            <Row>
              <Column span={{ xs: false, sm: 2, md: 2.75, lg: 3.75 }} />
              <Column span={{ xs: 12, sm: 8, md: 6.5, lg: 4.5 }}>
                <View>
                  <Stack space="smaller">
                    <View style={{ marginTop: 100 }}>
                      <View style={{ marginBottom: 20 }}>
                        <Text style={styles.text}>{translate("authStack.checkSpam")}</Text>
                      </View>
                      <Button
                        text={translate("authStack.returnToLogin") as string}
                        mode="contained"
                        onPress={returnToLoginHandler}
                        loading={isLoading}
                        textStyle={{ fontFamily: "Lato_700Bold" }}
                        {...testProps("sign-up-confirmed-return-to-login")}
                      />
                    </View>
                  </Stack>
                </View>
              </Column>
              <Column span={{ xs: false, sm: 2, md: 2.75, lg: 3.75 }} />
            </Row>
          </Container>
        </Grid>
      </ScrollView>
      <Footer />
    </SafeAreaView>
  );
};

const getStyles = (theme: ThemeType) => {
  const { colors, fontSize, spacing } = theme;
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: themeUiComponent.colors.white,
    },
    scrollView: { flexGrow: 0 },
    scrollableArea: {},
    inner: {
      ...domusoResponsiveStyleHelper({
        webPhone: {},
        webTablet: {},
        webDesktop: {},
        iosPhone: {},
        iosTablet: {},
        androidPhone: {},
        androidTablet: {},
      }),
    },
    heading: {
      fontSize: fontSize.largerPlus,
      fontWeight: "bold",
    },
    subHeading: {
      fontSize: 16,
      textAlign: "center",
      color: colors.text,
      fontWeight: "400",
    },
    button: {
      marginTop: spacing.medium,
    },
    flexCenter: {
      display: "flex",
      alignItems: "center",
    },
    link: {
      fontSize: fontSize.large,
      textDecorationLine: "underline",
    },
    text: {
      ...typography.title2,
      color: colors.text,
      fontWeight: "400",
      textAlign: "center",
    },
    bold: {
      fontWeight: "bold",
    },
  });
};
